

export const MarketplacePage = () => {
    return (
        <div className="relative">
            MarketplacePage
        </div>
    )
}

export default MarketplacePage